"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.changeDashboardLayout = void 0;
const types_1 = require("../../types");
const command_manager_1 = require("../../command_manager");
const dashboard_1 = require("../../model/dashboard");
const store_1 = require("../../exports/store");
exports.changeDashboardLayout = {
    undoable: false,
    execute(context, options) {
        const { model: state } = context;
        const { dashboardId, layout } = options;
        const installedWidgetIds = store_1.Selectors.getInstalledWidgetInDashboard(state);
        if (!installedWidgetIds) {
            return null;
        }
        const ids = layout.map(item => { return item.id; });
        const _ids = [...new Set([...ids, ...installedWidgetIds])];
        if (_ids.length !== ids.length) {
            return null;
        }
        const dashboardSnapshot = store_1.Selectors.getDashboardSnapshot(state);
        if (!dashboardSnapshot) {
            return null;
        }
        const changeDashBoardLayoutAction = dashboard_1.DashboardAction.changeWidgetLayout2Action(dashboardSnapshot, { layout: layout });
        if (!changeDashBoardLayoutAction) {
            return null;
        }
        return {
            result: command_manager_1.ExecuteResult.Success,
            resourceId: dashboardId,
            resourceType: types_1.ResourceType.Dashboard,
            actions: changeDashBoardLayoutAction,
        };
    },
};
//# sourceMappingURL=change_dashboard_layout.js.map